// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ak-z","breadcrumbItem":"bk-z"};